export default {"src":"/_next/static/media/custom-policy-drafting.da773686.svg","height":808,"width":909,"blurWidth":0,"blurHeight":0};